// components/ClearableTextarea.jsx
import React, { forwardRef } from "react";

const ClearableTextarea = forwardRef(function ClearableTextarea(
  {
    value,
    onChange,
    placeholder = "",
    maxLength,
    rows = 5,
    className = "",
    textareaClassName = "",
    clearButtonAriaLabel = "텍스트 모두 지우기",
    allowEscapeClear = true,
    disabled = false,
    name,
    id,
    onClear, // 선택 콜백
    showClearWhen = (v) => v != null && String(v).trim() !== "",
    ...rest
  },
  ref
) {
  const handleClear = () => {
    onClear?.();
    onChange?.({ target: { value: "" } }); // 부모 onChange 재사용
  };

  const handleKeyDown = (e) => {
    if (allowEscapeClear && e.key === "Escape") handleClear();
  };

  return (
    <div className={`relative ${className}`}>
      <textarea
        ref={ref}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        maxLength={maxLength}
        rows={rows}
        disabled={disabled}
        className={`w-full border border-border-default px-[16px] py-[12px] rounded-[12px] 
          focus:border-border-primary focus-visible:border-border-primary
          focus:outline-none focus-visible:outline-none
          ${textareaClassName}`}
        {...rest}
      />
      {showClearWhen(value) && !disabled && (
        <button
          type="button"
          aria-label={clearButtonAriaLabel}
          onClick={handleClear}
          className="absolute right-2 top-2 px-2 py-1 text-gray-400 hover:text-gray-600 rounded focus-visible:ring-2 focus-visible:ring-offset-2"
        >
          ×
        </button>
      )}
    </div>
  );
});

export default ClearableTextarea;
